import { render, staticRenderFns } from "./CreatePatient.vue?vue&type=template&id=01ea4d32&"
import script from "./CreatePatient.vue?vue&type=script&lang=js&"
export * from "./CreatePatient.vue?vue&type=script&lang=js&"
import style0 from "./CreatePatient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports